import { createProvider } from '@spotify-internal/transport/lib/providers/endpoints/xresolve';
import { createTransport } from '@spotify-internal/transport';
// Helper functions
function hasEndpoint(override) {
    return typeof override === 'string';
}
export function createTransportForHarmony(options) {
    if (typeof options.getToken !== 'function') {
        throw new TypeError('Argument options.getToken must be a function');
    }
    const provider = createProvider(options.xresolve);
    return createTransport({
        providers: {
            endpoints: (publicTransport) => provider(publicTransport).then((endpoints) => {
                const override = options.endpoints;
                if (override) {
                    for (const key in override) {
                        if (override.hasOwnProperty(key)) {
                            const endpoint = override[key];
                            if (hasEndpoint(endpoint)) {
                                endpoints[key] = endpoint;
                            }
                        }
                    }
                }
                return endpoints;
            }),
            token: () => new Promise((resolve) => {
                options.getToken((token, optTTL) => {
                    if (typeof optTTL !== 'undefined') {
                        resolve([token, optTTL]);
                        return;
                    }
                    resolve(token);
                });
            }),
        },
        disconnectBeforeUnload: options.disconnectBeforeUnload,
        forcePolyfillTypes: options.forcePolyfillTypes,
        reconnectionRetries: options.reconnectionRetries,
        requestMode: options.requestMode || 'fetch',
    });
}
//# sourceMappingURL=create_transport.js.map